import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { initRum } from "./integrations/datadog-rum";
import { FeatureFlagProvider } from "./config/FeatureFlagProvider";
import { AuthKitProvider } from "@workos-inc/authkit-react";
import { QueryProvider } from "./lib/react-query/QueryProvider";
import "./styles/styles.scss";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./utils/styleVariables";
import { getAuthConfig } from "./config/authConfig";
import Authenticated from "./Authenticated";
import { loadReleaseMetadata } from "./config/release";
import GlobalToastProvider from "./components/GlobalToastProvider";

initRum();

// Load and log release metadata
loadReleaseMetadata()
  .then((release) => {
    console.group("🚀 GXM Application");
    console.log("Version:", release.version);
    console.log("Manifest:", release.manifest);
    console.log("Git SHA:", release.sha);
    console.log("Built:", release.built_at);
    console.log("Environment:", release.environment);
    console.groupEnd();
  })
  .catch((error) => {
    console.warn("Failed to load release metadata:", error);
  });

const { clientId, redirectUri, isDev } = getAuthConfig();

ReactDOM.createRoot(document.getElementById("root")).render(
  <AuthKitProvider
    clientId={clientId}
    redirectUri={redirectUri}
    devMode={isDev}
    onRedirectCallback={(state) => {
      if (state?.returnTo) {
        window.history.replaceState(null, "", state.returnTo);
      }
    }}
  >
    <FeatureFlagProvider>
      <QueryProvider>
        <Provider store={store}>
          <GlobalToastProvider>
            <Authenticated>
              <App />
            </Authenticated>
          </GlobalToastProvider>
        </Provider>
      </QueryProvider>
    </FeatureFlagProvider>
  </AuthKitProvider>,
);
